import React from 'react';
import {GlobeIcon} from "@heroicons/react/outline";
import Field from "../../../components/Form/Field";

type Props = {
    name: string
}

function MapStyleEditor({name}: Props) {
    return (
        <fieldset>
            <div className="bg-white rounded-md">
                <div className="flex gap-3">
                    <div className="w-1/3 lg:w-1/4 flex-0 min-w-0">
                        <Field
                          label='Name *'
                          hint='74 max chars'
                          type="text"
                          name={`${name}.name`}
                          id={`${name}.name`}
                          maxLength={75}
                          placeholder="Name"
                        />
                    </div>
                    <div className="relative flex-1 min-w-0">
                        <Field
                          label='Style URL *'
                          hint='255 max chars'
                          type="text"
                          id={`${name}.url`}
                          name={`${name}.url`}
                          maxLength={255}
                          placeholder="mapbox://styles/username/style-id"
                          icon={GlobeIcon}
                        />
                    </div>
                </div>
            </div>
        </fieldset>
    );
}

export default MapStyleEditor;